// IE also doesn't set `defaultPrevented` for custom events
// when you call `preventDefault`. So, we need to define setter by ourselves.
// http://stackoverflow.com/questions/23349191/event-preventdefault-is-not-working-in-ie-11-for-custom-events
function overwritePreventDefault(event) {
    var nativePreventDefault = event.preventDefault;
    event.preventDefault = function () {
        if (!event.cancelable) {
            return;
        }
        nativePreventDefault.call(event);
        // we need try ... catch here because PhantomJS goes in this branch as well
        // and does not allow to override native properties and we need it for IE
        try {
            Object.defineProperty(event, 'defaultPrevented', {
                get: function () { return true; }
            });
        }
        catch (e) {
            // nothing to do here
        }
    };
}
// `isPropagationStopped` is a part of specification:
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/events.html#Events-Event-isPropagationStopped
// but none of the browsers is supporting that. We need to know
// if `stopPropagation()` was called on the custom event to call it on the native one.
function overwriteStopPropagation(event) {
    var nativeStopPropagation = event.stopPropagation;
    event.stopPropagation = function () {
        nativeStopPropagation.call(event);
        event.isPropagationStopped = true;
    };
}
export function createCustomEvent(eventType, detail, bubbles, cancelable) {
    if (bubbles === void 0) { bubbles = true; }
    if (cancelable === void 0) { cancelable = true; }
    var event;
    // IE doesn't have a CustomEvent constructor but
    // MDN says the initCustomEvent alternative should not
    // be used, so we use one or the other depending on what's
    // available. PhantomJS behaves the same way.
    if (typeof CustomEvent !== 'function') {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventType, bubbles, cancelable, detail);
        overwritePreventDefault(event);
    }
    else {
        event = new CustomEvent(eventType, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
    }
    overwriteStopPropagation(event);
    return event;
}
//# sourceMappingURL=events.js.map